/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import './Tooltip.css';

interface TooltipProps {
    fieldId: string;
}

interface TooltipWorkState {
    tooltipIsOpen: boolean;
}

export class TooltipComponent extends React.Component<TooltipProps, TooltipWorkState> {
    constructor(props: any) {
        super(props);
        this.state = {
            tooltipIsOpen: false,
        };
        this.showTooltip = this.showTooltip.bind(this);
        this.hideTooltip = this.hideTooltip.bind(this);
    }

    handleOnClick(tooltipIsOpen: boolean) {
        if (tooltipIsOpen) {
            this.hideTooltip();
        } else {
            this.showTooltip();
        }
    }

    showTooltip() {
        this.setState({
            tooltipIsOpen: true,
        });
    }

    hideTooltip() {
        this.setState({
            tooltipIsOpen: false,
        });
    }

    public render() {
        return (
            <div
                className="sid-form-tooltip"
                onMouseEnter={this.showTooltip}
                onMouseLeave={this.hideTooltip}
            >
                <button
                    type="button"
                    className="sid-form-tooltip-link"
                    onFocus={this.showTooltip}
                    onBlur={this.hideTooltip}
                    onClick={() => this.handleOnClick(this.state.tooltipIsOpen)}
                    aria-labelledby={`${this.props.fieldId}-tooltip`}
                    aria-describedby={`${this.props.fieldId}-tooltip`}
                    aria-label="Why do you ask for my work email address?"
                >
                    <i className="fa fa-question-circle-o" />
                </button>
                {
                    this.state.tooltipIsOpen
                        ? (
                            <div className="sid-form-tooltip__container" id={`${this.props.fieldId}-tooltip`} role="tooltip">
                                <div className="sid-form-tooltip__caret" />
                                <div className="sid-form-tooltip__tooltip">

                                    <div className="sid-form-tooltip__text sid-form-tooltip__content">
                                        <div className="sid-tooltip-top">
                                            <FormattedHTMLMessage
                                                id={`${this.props.fieldId}.tooltipTextTop`}
                                                defaultMessage="This information is needed to verify your status."
                                            />
                                        </div>
                                    </div>


                                    <div className="sid-form-tooltip__text sid-form-tooltip__content-bottom">
                                        <div className="sid-tooltip-bottom">
                                            <FormattedHTMLMessage
                                                id={`${this.props.fieldId}.tooltipTextBottom`}
                                                defaultMessage="This information is needed to verify your status."
                                            />
                                        </div>
                                    </div>


                                </div>
                            </div>
                        )
                        : null
                }
            </div>
        );
    }
}
